import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { MASKS } from 'ng-brazil';
import { ArqProposta } from 'src/app/models/arq-proposta';
import { TipoArquivo } from 'src/app/models/enum';
import { TemplateEmail, AnexoTemplateEmail } from 'src/app/models/template-email';
import { Variavel } from 'src/app/models/variavel';
import { ArquivoService } from 'src/app/services/arquivo.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { TemplateEmailService } from 'src/app/services/template-email.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { VariaveisService } from 'src/app/services/variaveis.service';
import { ViaCepService } from 'src/app/services/via-cep.service';
import insertTextAtCursor from 'insert-text-at-cursor';

// jquery
declare const $: any;

@Component({
  selector: 'app-cadastrar-template-email',
  templateUrl: './cadastrar-template-email.component.html',
  styleUrls: ['./cadastrar-template-email.component.scss']
})
export class CadastrarTemplateEmailComponent implements OnInit, OnDestroy, AfterViewInit {

  // variáveis
  idTemplateEmail;
  templateEmail = new TemplateEmail();
  editando = false;
  carregando = true;
  public MASKS = MASKS;
  tipos = [{ id: '0', nome: 'Proposta' }, { id: '1', nome: 'Contrato' }];
  tipoSelecionado = '0';
  padrao = false;
  selectedFile: File;
  nomeArquivoBanco = '';
  variaveis: Variavel[] = [];
  grupos: string[] = [];
  autorModal = 0; // 0 - assunto | 1 - texto
  variavelSelecionada: Variavel;
  tiposDeTemplate = [{ id: 0, nome: 'Normal' }, { id: 1, nome: 'Boas-vindas' }, { id: 2, nome: 'Cancelamento' }, { id: 3, nome: 'Contrato' }, { id: 4, nome: 'Aviso Estoque Mínimo' }, { id: 5, nome: 'Aviso mudança para "Em Andamento" da ocorrência' }];

  configuracaoTexto: any = {
    lang: 'pt-BR',
    toolbar: [
      ['style', ['bold', 'italic', 'underline', 'clear']],
      ['fontsize', ['fontsize']],
      ['para', ['ul', 'ol']],
      ['paragraph'],
      ['code', ['codeview']],
      //['mybutton', ['vars']],
      ['insert', ['link', 'picture']],
      ['testBtn']
      // ['template', ['importar']],
      // ['anexo', ['btnfile']]
    ],
    height: '300px',
    placeholder: 'Texto do Email',
    buttons: {
      'testBtn': (context) => {
        const ui = $.summernote.ui;
        const button = ui.button({
          contents: 'Variáveis',
          tooltip: 'Variáveis',
          container: '.note-editor',
          className: 'note-btn',
          click: () => {

            // context.invoke('editor.insertText', 'teste');

            // return;
            this.autorModal = 1;
            this.variavelSelecionada = undefined;
            context.invoke('saveRange');
            $('#modalVariaveis').modal({});

            $('#modalVariaveis').on('hidden.bs.modal', (e) => {

              if (this.variavelSelecionada && this.autorModal == 1) {
                context.invoke('restoreRange');
                context.invoke('focus');
                context.invoke('editor.insertText', this.variavelSelecionada.texto);
              }
              $('#modalVariaveis').off('hidden.bs.modal');
            });
          }
        });
        return button.render();
      }
    }
  };

  constructor(private route: ActivatedRoute, private notificacaoService: NotificacaoService,
    private templateEmailService: TemplateEmailService, private utilitarioService: UtilitarioService,
    private router: Router, private viaCepService: ViaCepService, private arquivoService: ArquivoService,
    private globalService: GlobalService, private carregandoService: CarregandoService, public dialog: MatDialog,
    private variaveisService: VariaveisService) {
    if (this.router.getCurrentNavigation().extras.state && this.router.getCurrentNavigation().extras.state.tipo) {
      this.tipoSelecionado = this.router.getCurrentNavigation().extras.state.tipo;
    }
  }

  ngOnInit() {


    this.buscarVariaveis();
    // se for edição, busca o templateEmail do id passado
    if (this.route.snapshot.paramMap.get('id')) {
      this.idTemplateEmail = this.route.snapshot.paramMap.get('id');
      this.editando = true;
      this.buscarTemplateEmail();
    } else {
      this.templateEmail = new TemplateEmail();
      this.templateEmail.tipo = 0;
      this.templateEmail.anexos = [];
      this.atualizaDadosTemplateEmail();
    }
  }




  ngAfterViewInit(): void {
    $(document).ready(function () {



      $('input').keypress(function (e) {

        let code = null;
        code = (e.keyCode ? e.keyCode : e.which);
        return (code === 13) ? false : true;

      });

      $('input').keydown(function (e) {
        // Obter o próximo índice do elemento de entrada de texto
        let next_idx = $('input').index(this) + 1;

        // Obter o número de elemento de entrada de texto em um documento html
        let tot_idx = $('body').find('input').length;

        // Entra na tecla no código ASCII
        if (e.keyCode === 13) {
          if (tot_idx === next_idx)
            // Vá para o primeiro elemento de texto
            $('input:eq(0)').focus();
          else
            // Vá para o elemento de entrada de texto seguinte
            $('input:eq(' + next_idx + ')').focus();
        }
      });
    });
  }

  buscarTemplateEmail() {

    this.carregandoService.mostra('buscaTemplateEmail');
    this.templateEmailService.consultarPorId(this.idTemplateEmail).subscribe(arq => {
      this.templateEmail = arq;
      // this.nomeArquivoBanco = this.templateEmail.nomearq;
      this.atualizaDadosTemplateEmail();
    }, (erro) => {
      this.carregandoService.esconde('buscaTemplateEmail');
      this.notificacaoService.erro(erro);
    });
  }

  atualizaDadosTemplateEmail() {

    // atualiza os campos de seleção
    // this.tipoSelecionado = this.tipos.find(s => s.id === this.templateEmail.tipo) ?
    //   this.tipos.find(s => s.id === this.templateEmail.tipo).id : '0';
    // this.padrao = this.templateEmail.padrao === 'S';
    this.carregando = false;

    this.carregandoService.esconde('buscaTemplateEmail');
  }

  salvar() {
    this.carregandoService.mostra('salvaTemplateEmail');
    this.templateEmail.id = this.idTemplateEmail;

    const dados = new FormData();

    dados.append('template[assunto]', this.templateEmail.assunto);
    dados.append('template[id]', this.templateEmail.id ? this.templateEmail.id.toString() : '0');
    dados.append('template[nome]', this.templateEmail.nome);
    dados.append('template[texto]', this.templateEmail.texto);
    dados.append('template[tipo]', this.templateEmail.tipo.toString());

    if (this.templateEmail.anexos && this.templateEmail.anexos.length > 0) {

      for (const [i, a] of this.templateEmail.anexos.entries()) {

        if (a.file) {
          dados.append(a.arquivo, a.file);
        }
        else if (a.idProposta) {
          dados.append('template[anexos][' + i + '][idProposta]', a.idProposta.toString());
        }
        dados.append('template[anexos][' + i + '][arquivo]', a.arquivo);
        dados.append('template[anexos][' + i + '][excluir]', a.excluir ? 'true' : 'false');
        dados.append('template[anexos][' + i + '][id]', a.id ? a.id.toString() : '0');
        dados.append('template[anexos][' + i + '][tipo]', a.tipo.toString());
      }
    }
    //this.createFormData(dados, this.templateEmail.anexos, 'template[anexos]');



    this.templateEmailService.salvar(dados).subscribe((resp) => {

      this.notificacaoService.sucesso('Modelo de Email salvo com sucesso!!!');
      this.router.navigate(['configuracoes/modelos-de-email']).then(() => {
        this.carregandoService.esconde('salvaTemplateEmail');
      });

    }, (erro) => {
      this.carregandoService.esconde('salvaTemplateEmail');
      this.notificacaoService.erro(erro);
    });

  }

  createFormData(formData, data, key) {
    if ((typeof data === 'object' && data !== null) || Array.isArray(data)) {
      for (let i in data) {
        if ((typeof data[i] === 'object' && data[i] !== null) || Array.isArray(data[i])) {
          this.createFormData(formData, data[i], key + '[' + i + ']');
        } else {
          formData.append(key + '[' + i + ']', data[i]);
        }
      }
    } else {
      formData.append(key, data);
    }
  }

  ngOnDestroy(): void {

  }

  onFileChanged(event) {

    if (event.target.files.length > 0) {
      const novoAnexo = new AnexoTemplateEmail();
      novoAnexo.file = event.target.files[0];
      novoAnexo.arquivo = novoAnexo.file.name;
      novoAnexo.tipo = 0;
      this.templateEmail.anexos.push(novoAnexo);
    }
  }

  baixarArquivo() {

    this.carregandoService.mostra('baixarArquivo');
    this.arquivoService.baixarArquivo(this.idTemplateEmail, TipoArquivo.ContratoProposta).subscribe(arq => {
      this.utilitarioService.saveBlob(arq, this.nomeArquivoBanco);
      this.carregandoService.esconde('baixarArquivo');
    }, (erro) => {
      this.carregandoService.esconde('baixarArquivo');
      this.notificacaoService.erro(erro);
    });

  }

  excluirAnexo(anexo: AnexoTemplateEmail) {
    if (anexo.id) {
      anexo.excluir = true;
    } else {
      this.templateEmail.anexos.splice(this.templateEmail.anexos.indexOf(anexo), 1);
    }
  }

  validaArquivo() {
    if (this.selectedFile) {
      return this.selectedFile.name.toLowerCase().endsWith('.docx');
    } else {
      return true;
    }
  }


  buscarVariaveis() {
    this.carregandoService.mostra('buscarVariaveis');

    this.variaveisService.consultarVariaveis().subscribe(
      (vars) => {
        this.variaveis = vars;
        this.grupos = [...new Set(this.variaveis.map(p => p.grupo))];

        this.carregandoService.esconde('buscarVariaveis');
      },
      (erro) => {
        this.carregandoService.esconde('buscarVariaveis');
        this.notificacaoService.erro(erro);
      }
    );
  }

  filtrarVariaveis(grupo) {
    return this.variaveis.filter(p => p.grupo === grupo);
  }

  selecionarVariavel(variavel: Variavel) {
    this.variavelSelecionada = variavel;
    $('#modalVariaveis').modal('hide');
  }

  mostrarVariaveisAssunto() {
    this.autorModal = 0;
    this.variavelSelecionada = undefined;
    $('#modalVariaveis').modal({});

    $('#modalVariaveis').on('hidden.bs.modal', (e) => {

      if (this.variavelSelecionada && this.autorModal == 0) {
        const el = document.getElementById('assunto');
        insertTextAtCursor(el, this.variavelSelecionada.texto);
      }
      $('#modalVariaveis').off('hidden.bs.modal');
    });
  }



  anexosAtivos() {
    if (this, this.templateEmail.anexos) {
      return this.templateEmail.anexos.filter(p => !p.excluir);
    } else {
      return [];
    }
  }

}
